import React, { useEffect, useRef, useState } from "react"
import { Redirect, Route, Switch, withRouter } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
  getAddress1,
  getAddress2,
  getAddressState,
  getCity,
  getDateOfBirth,
  getFirstName,
  getGenderIdentity,
  getIsUsa,
  getNonUsaAddress,
  getPersonalEmail,
  getSex,
  getZip
} from "../../../../reducers/userInfo"
import moment from "moment"
import { updateDateOfBirth, updatePersonalEmails } from "../../../../actions"
import { updateGenderIdentity, updateSex, updateUserInfo } from "../../../../actions/userActions"
import { AboutYouInto } from "./AboutYouIntro"
import { PersonalEmail } from "./AboutYouPersonalEmail"
import { AboutYouAddress } from "./AboutYouAddress"
import { AboutYouDateOfBirth } from "./AboutYouDateOfBirth"
import { AboutYouSex } from "./AboutYouSex"
import { GenderIdentity } from "./AboutYouGenderIdentity"
import { regexes } from "utils/Regexes"

const AboutYou = (props) => {
  const [personalEmail, setPersonalEmail] = useState(null)
  const [validEmail, setValidEmail] = useState(true)
  const [dateOfBirth, setDateOfBirth] = useState(null)
  const [validDateOfBirth, setValidDateOfBirth] = useState(true)

  //Given the complex input, this ref is needed for getting the moment and running validation
  const dateOfBirthRef = useRef()
  const {
    previousPersonalEmail,
    firstName,
    previousDateOfBirth,
    address1,
    address2,
    city,
    state,
    zip,
    nonUsaAddress,
    isUsa,
    sex,
    genderIdentity
  } = useSelector((state) => ({
    previousPersonalEmail: getPersonalEmail(state),
    firstName: getFirstName(state),
    previousDateOfBirth: getDateOfBirth(state),
    address1: getAddress1(state),
    address2: getAddress2(state),
    city: getCity(state),
    state: getAddressState(state),
    zip: getZip(state),
    nonUsaAddress: getNonUsaAddress(state),
    isUsa: getIsUsa(state),
    sex: getSex(state),
    genderIdentity: getGenderIdentity(state)
  }))
  const dispatch = useDispatch()

  useEffect(() => {
    setPersonalEmail(previousPersonalEmail)
    if (previousDateOfBirth != null) {
      setDateOfBirth(moment(previousDateOfBirth))
    }
  }, [previousDateOfBirth, previousPersonalEmail])

  const isValidEmail = (email) => {
    if (email == null || email === "") {
      return true
    }

    return regexes.email.test(email)
  }

  const updateContactEmailContainerFromForm = async () => {
    if (isValidEmail(personalEmail)) {
      setValidEmail(true)
      await dispatch(updatePersonalEmails(personalEmail, null))
      props.history.push("/fle/about-you/address")
    } else {
      setValidEmail(false)
    }
  }

  const updateAddressFromForm = async (data) => {
    await dispatch(updateUserInfo(data))
    props.history.push("/fle/about-you/date-of-birth")
  }

  const validateAndUpdateDateOfBirth = async () => {
    const dobInputIsValid = dateOfBirthRef.current.validate()
    setValidDateOfBirth(dobInputIsValid)
    if (dobInputIsValid) {
      const dobMoment = dateOfBirthRef.current.getMoment()
      await dispatch(updateDateOfBirth(dobMoment, null))
      props.history.push("/fle/about-you/sex")
    }
  }

  const updateSexAndNext = async (sex) => {
    await dispatch(updateSex(sex, null))
    nextScreenSex()
  }
  const nextScreenSex = () => {
    props.history.push("/fle/about-you/gender-identity")
  }

  const updateGenderIdentityAndNext = async (genderIdentity) => {
    await dispatch(updateGenderIdentity(genderIdentity, null))
    nextScreenGenderIdentity()
  }
  const nextScreenGenderIdentity = (preserveHistory = true) => {
    if (preserveHistory) {
      props.history.push("/fle/partner")
    } else {
      props.history.replace("/fle/partner")
    }
  }

  return (
    <Switch>
      <Route exact path="/fle/about-you">
        <Redirect to="/fle/about-you/intro" />
      </Route>
      <Route exact path="/fle/about-you/intro">
        <AboutYouInto />
      </Route>
      <Route exact path="/fle/about-you/email">
        <PersonalEmail
          personalEmail={personalEmail || ""}
          setPersonalEmail={setPersonalEmail}
          validEmail={validEmail}
          onComplete={updateContactEmailContainerFromForm}
          firstName={firstName}
        />
      </Route>
      <Route exact path="/fle/about-you/address">
        <AboutYouAddress
          address1={address1 ? address1 : ""}
          address2={address2}
          city={city}
          state={state}
          zip={zip}
          nonUsaAddress={nonUsaAddress}
          isUsa={isUsa}
          onComplete={updateAddressFromForm}
        />
      </Route>
      <Route exact path="/fle/about-you/date-of-birth">
        <AboutYouDateOfBirth
          dateOfBirth={dateOfBirth}
          validDateOfBirth={validDateOfBirth}
          dateOfBirthRef={dateOfBirthRef}
          onComplete={validateAndUpdateDateOfBirth}
        />
      </Route>
      <Route exact path="/fle/about-you/sex">
        <AboutYouSex sex={sex} updateSex={updateSexAndNext} onSkip={nextScreenSex} />
      </Route>
      <Route exact path="/fle/about-you/gender-identity">
        <GenderIdentity
          genderIdentity={genderIdentity}
          updateGenderIdentity={updateGenderIdentityAndNext}
          onSkip={nextScreenGenderIdentity}
        />
      </Route>
    </Switch>
  )
}

export default withRouter(AboutYou)
